import { createURL } from 'expo-linking';

import type { NotificationData } from '@/features/notifications/types/notificationData';
import { getRelatedEntityId } from '@/features/notifications/utils/notificationData';

export const getNotificationLink = (
  data?: NotificationData
): string | undefined => {
  try {
    if (!data) return;

    switch (data.eventName) {
      case 'ClientInformationMessageEvent': {
        // TODO startpage with parameter for message?
        break;
      }
      case 'ClientPostCreateConfirmation':
      case 'ClientReplyToCommentEvent':
      case 'ClientCommentOnPostEvent':
      case 'ClientPollExpiredEvent': {
        // e.g. post-detail?id=2a8ed6a7-fccd-41b3-8bcc-fb35d1de040c1
        const postId = getRelatedEntityId('postId', data);
        if (!postId) return;
        return createURL('/post-detail', {
          queryParams: { id: postId }
        });
      }
      case 'ClientChatMessageReceivedEvent': {
        // e.g. chat?id=647eeb45-ca3d-4fa4-b8a1-a7374b4a9929
        const chatId = getRelatedEntityId('chatId', data);
        if (!chatId) return;
        return createURL('/chat', {
          queryParams: { id: chatId }
        });
      }
      case 'ClientOrganizationMemberAddedEvent': {
        // e.g. organization-detail?id=bd0792ae-8d9d-5f05-9e18-816d3d2b0d4d
        const organizationId = getRelatedEntityId('organizationId', data);
        if (!organizationId) return;
        return createURL('/organization-detail', {
          queryParams: { id: organizationId }
        });
      }
      case 'ClientPersonVerifyEmailAddressResponse': {
        // TODO: open EmailVerificationSuccess view (start page or profile page with parameter?)
        break;
      }
      case 'ClientGroupPendingJoinAcceptConfirmation': {
        // e.g. group-detail?groupId=71fb5ea3-c18b-4ff3-8d69-7a2b5dcfed42
        const groupId = getRelatedEntityId('groupId', data);
        if (!groupId) return;

        return createURL('/group-detail', {
          queryParams: { groupId: groupId }
        });
      }
      case 'ClientGroupNewJoinRequestEvent': {
        const groupId = getRelatedEntityId('groupId', data);
        if (!groupId) return;

        return createURL('/group-requests', {
          queryParams: { groupId: groupId }
        });
      }
      default: {
        return;
      }
    }
  } catch (error) {
    console.error(error);
  }

  return;
};
